module.exports = __webpack_public_path__ + "img/144.54dc62ab.jpg";